import gql from "graphql-tag";

export default gql`
  mutation sendMessage($conversationId: Int!, $content: String!) {
    sendMessage(input: { conversationId: $conversationId, content: $content }) {
      privateMessage {
        id
        conversationId
        senderId
        content
        readAt
        createdAt
        userBySenderId {
          id
          firstname
          lastname
          profilePictureUrl
        }
      }
    }
  }
`;
